import React, { useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { designActions } from '../../actions';
import { DesignContext } from '../../containers/GraphicBuilder/GraphicBuilder';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import './Alignment.css';
import { ReactSVG } from 'react-svg';
import * as icons from '../../assets/images/toolbarIcons/_toolbarIcons';

const Alignment = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { activePageRef } = useContext(DesignContext);
  const pageWidth = useSelector(state => state.design.width);
  const pageHeight = useSelector(state => state.design.height);
  const pageScale = useSelector(state => state.design.scale) / 100;
  const selectedEntities = useSelector(state => state.design.selectedEntity);
  const entity = useSelector(state => state.design.entitiesState);

  const getTransform = (id, style) => {
    // if (!style.width || !style.height) {
    //   const moveables = document.querySelectorAll('.moveable');

    //   Array.from(moveables).map(moveable => {
    //     if (moveable.id.charAt(0) != 'B') {
    //       moveable.style.width = moveable.offsetWidth + 'px';
    //       moveable.style.height = moveable.offsetHeight + 'px';
    //       const moveableId = parseInt(moveable.dataset.target.split('_')[1]);
    //       if (moveableId === id) {
    //         style = {
    //           ...style,
    //           width: moveable.offsetWidth + 'px',
    //           height: moveable.offsetHeight + 'px',
    //         };
    //       }
    //     }
    //   });
    // }

    const currentStyle = style.transform.replace(/NaN/g, '0');
    const currentTransform = {};
    // eslint-disable-next-line no-undef
    let matrix = new WebKitCSSMatrix(currentStyle);

    let angle = Math.round(Math.atan2(matrix.b, matrix.a) * (180 / Math.PI));

    // if (!currentTransform.width) currentTransform.width = document.getElementById(`_${}_`)
    const currentTarget = document.getElementById(`_${id}_`);
    currentTransform.rotate = angle;
    currentTransform.tx = matrix.m41;
    currentTransform.ty = matrix.m42;
    currentTransform.tz = matrix.m43;
    currentTransform.sx = Math.sqrt(Math.pow(matrix.a, 2) + Math.pow(matrix.c, 2));
    currentTransform.sy = Math.sqrt(Math.pow(matrix.b, 2) + Math.pow(matrix.d, 2));
    currentTransform.width =
      currentTarget.getBoundingClientRect().width / currentTransform.sx / pageScale; //* currentTransform.sx;
    currentTransform.height =
      currentTarget.getBoundingClientRect().height / currentTransform.sy / pageScale; //* currentTransform.sy;
    if (angle) {
      currentTransform.wDiff = (currentTransform.width - currentTarget.offsetWidth) / 2;
      currentTransform.hDiff = (currentTransform.height - currentTarget.offsetHeight) / 2;
    } else {
      currentTransform.wDiff = 0;
      currentTransform.hDiff = 0;
    }
    // if (!style.width) {
    //   currentTransform.width = currentTarget.offsetWidth; //* currentTransform.sx;
    // } else {
    //   currentTransform.width = parseFloat(style.width);
    // }
    // if (!style.height) {
    //   currentTransform.height = currentTarget.offsetHeight; //* currentTransform.sy;
    // } else {
    //   currentTransform.height = parseFloat(style.height);
    // }
    return currentTransform;
  };

  const saveAlign = finalTransforms => {
    const changes = [];
    finalTransforms.forEach(finalTransform => {
      if (finalTransform.id !== -1) {
        const transform = {
          transform: `translateZ(${finalTransform.tz}px) translateX(${finalTransform.tx}px) translateY(${finalTransform.ty}px) rotate(${finalTransform.rotate}deg) scaleX(${finalTransform.sx}) scaleY(${finalTransform.sy})`,
        };
        const masterStyle = { master: { ...entity[finalTransform.id].style.master, ...transform } };
        changes.push({ id: finalTransform.id, data: masterStyle });
      }
    });
    dispatch(designActions.changeGroupEntityStyle(activePageRef.current, changes));
  };

  let titleText;
  if (selectedEntities.id && selectedEntities.id.length > 1) {
    titleText = t('alignElements');
  } else {
    titleText = t('alignToPage');
  }

  const align = position => {
    let entities = [];
    let entitiesArray;
    let withPage = false;
    if (selectedEntities.id.length) {
      entitiesArray = selectedEntities.id;
    } else {
      entitiesArray = [selectedEntities.id];
      withPage = true;
      entities.push({
        id: -1,
        ntx: 0,
        nty: 0,
        nw: pageWidth,
        nh: pageHeight,
        txe: pageWidth,
        tye: pageHeight,
        zx: 1,
        zy: 1,
      });
    }

    const newTransform = [];
    entitiesArray.forEach(entityId => {
      const currentTransform = getTransform(entityId, entity[entityId].style.master);
      const zx = (currentTransform.width * currentTransform.sx - currentTransform.width) / 2;
      const zy = (currentTransform.height * currentTransform.sy - currentTransform.height) / 2;
      const ntx = -(zx - currentTransform.tx);
      const nty = -(zy - currentTransform.ty);

      const nw = currentTransform.width * currentTransform.sx;
      const nh = currentTransform.height * currentTransform.sy;
      entities.push({
        ...currentTransform,
        id: entityId,
        ntx: ntx,
        nty: nty,
        nw: nw,
        nh: nh,
        txe: ntx + nw,
        tye: nty + nh,
        zx: zx,
        zy: zy,
      });
    });
    const entitiesTX = _.orderBy(entities, ['ntx'], ['asc']);
    const entitiesTXE = _.orderBy(entities, ['txe'], ['desc']);
    const entitiesTY = _.orderBy(entities, ['nty'], ['asc']);
    const entitiesTYE = _.orderBy(entities, ['tye'], ['desc']);
    switch (position) {
      case 'left':
        entities.forEach(entity => {
          if (withPage) {
            newTransform.push({ ...entity, tx: entity.zx + entity.wDiff });
          } else {
            newTransform.push({ ...entity, tx: entity.zx + entitiesTX[0].ntx + entity.wDiff });
          }
        });
        break;
      case 'right':
        entities.forEach(entity => {
          if (withPage) {
            newTransform.push({ ...entity, tx: entity.zx + pageWidth - entity.nw + entity.wDiff });
          } else {
            newTransform.push({
              ...entity,
              tx: entity.zx + entitiesTXE[0].txe - entity.nw + entity.wDiff,
            });
          }
        });
        break;
      case 'center':
        entities.forEach(entity => {
          if (withPage) {
            const center = entity.zx + pageWidth / 2; //* entitiesID[0].sx;
            newTransform.push({
              ...entity,
              tx: center - entity.nw / 2 + entity.wDiff,
            });
          } else {
            const center = (entity.zx * 2 + entitiesTX[0].ntx + entitiesTXE[0].txe) / 2;
            newTransform.push({
              ...entity,
              tx: center - entity.nw / 2 + entity.wDiff,
            });
          }
        });
        break;
      case 'top':
        entities.forEach(entity => {
          if (withPage) {
            newTransform.push({ ...entity, ty: entity.zy + entity.hDiff });
          } else {
            newTransform.push({ ...entity, ty: entity.zy + entitiesTY[0].nty + entity.hDiff });
          }
        });
        break;
      case 'bottom':
        entities.forEach(entity => {
          if (withPage) {
            newTransform.push({
              ...entity,
              ty: entity.zy + pageHeight - entity.nh + entity.hDiff,
            });
          } else {
            newTransform.push({
              ...entity,
              ty: entity.zy + entitiesTYE[0].tye - entity.nh + entity.hDiff,
            });
          }
        });
        break;
      case 'middle':
        entities.forEach(entity => {
          if (withPage) {
            const middle = entity.zy + pageHeight / 2; // * entitiesID[0].sy;
            newTransform.push({
              ...entity,
              ty: middle - entity.nh / 2 + entity.hDiff,
            });
          } else {
            const middle = (entity.zy * 2 + entitiesTY[0].nty + entitiesTYE[0].tye) / 2;
            newTransform.push({
              ...entity,
              ty: middle - entity.nh / 2 + entity.hDiff,
            });
          }
        });
        break;
      default:
        return;
    }

    saveAlign(newTransform);
  };

  return (
    <div className="toolsHolderContainer alignment">
      <div className="title">{titleText}</div>
      <div className="row">
        <button className="ui button" title="Top" onMouseDown={() => align('top')}>
          <ReactSVG className="svgIcon" src={icons.alignTop} />
          <span>{t('top')}</span>
        </button>
        <button className="ui button" title="Right" onMouseDown={() => align('right')}>
          <ReactSVG className="svgIcon" src={icons.alignRight} />
          <span>{t('right')}</span>
        </button>
      </div>
      <div className="row">
        <button className="ui button" title="Middle" onMouseDown={() => align('middle')}>
          <ReactSVG className="svgIcon" src={icons.alignMiddle} />
          <span>{t('middle')}</span>
        </button>
        <button className="ui button" title="Center" onMouseDown={() => align('center')}>
          <ReactSVG className="svgIcon" src={icons.alignCenter} />
          <span>{t('center')}</span>
        </button>
      </div>
      <div className="row">
        <button className="ui button" title="Bottom" onMouseDown={() => align('bottom')}>
          <ReactSVG className="svgIcon" src={icons.alignBottom} />
          <span>{t('bottom')}</span>
        </button>
        <button className="ui button" title="Left" onMouseDown={() => align('left')}>
          <ReactSVG className="svgIcon" src={icons.alignLeft} />
          <span>{t('left')}</span>
        </button>
      </div>
    </div>
  );
};

export default Alignment;
